import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/action' },
  { name: '热门', path: '/#popular' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl font-bold font-heading tracking-tight ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              韩漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap hover:text-accent-500 ${
                  location.pathname === link.path
                    ? 'text-accent-500'
                    : scrolled
                    ? 'text-foreground-700'
                    : 'text-white/90'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
                scrolled
                  ? 'text-foreground-600 hover:bg-background-200'
                  : 'text-white/80 hover:bg-white/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category/action"
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full ${
              scrolled ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-accent-100 text-accent-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category/action"
              className="bg-primary-500 text-background-50 text-center py-2.5 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer mt-2"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}